/// <amd-module name="TFS/Token/PatTokenPage/Utils/ScopeUtils" />
import * as React from 'react';

import { ScopeData } from 'Generated/Contracts';

export default class ScopeUtils extends React.Component {

    public static isParentOf = (parent: ScopeData, potentialChild: ScopeData, allScopes: ScopeData[]): boolean => {
        const childList = allScopes.filter(item => item.key === parent.inheritsFrom);
        if (childList.length === 0) {
            return false;
        }
        var child = childList[0];

        if (child.key === potentialChild.key) {
            return true;
        } else {
            return ScopeUtils.isParentOf(child, potentialChild, allScopes);
        }
    }
}
